import { Typography } from "@mui/material";

export default function TypoCaption({ children, color }) {
  return (
    <Typography variant="caption" sx={{ color: color || "#fff" }}>
      {children}
    </Typography>
  );
}
